import React, { useEffect, useState } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);


  const [randomImages, setRandomImages] = useState([]);

  const images = [
    // new ambiance
    "/images/image-0000035.webp",
    "/images/image-0000036.webp",
    "/images/image-0000037.webp",
    "/images/image-0000038.webp",
    "/images/image-0000039.webp",
    "/images/image-0000040.webp",
    "/images/image-0000041.webp",
    "/images/image-0000042.webp",
    "/images/image-0000043.webp",
    "/images/image-0000044.webp",
    "/images/image-0000045.webp",
    "/images/image-0000046.webp",
    "/images/image-0000047.webp",
    "/images/image-0000048.webp",
    "/images/image-0000049.webp",
    "/images/image-0000050.webp",
    "/images/image-0000051.webp",
    "/images/image-0000052.webp",
    "/images/image-0000053.webp",
    "/images/image-0000054.webp",
    "/images/image-0000055.webp",
    "/images/image-0000056.webp",
    "/images/image-0000057.webp",
    "/images/image-0000058.webp",
    "/images/image-0000059.webp",
    "/images/image-0000060.webp",
    "/images/image-0000061.webp",
    "/images/image-0000062.webp",
    "/images/image-0000063.webp",
    "/images/image-0000064.webp",
    "/images/image-0000065.webp",
    "/images/image-0000066.webp",
    "/images/image-0000067.webp",
    "/images/image-0000068.webp",
    "/images/image-0000069.webp",
    "/images/image-0000070.webp",
    "/images/image-0000071.webp",
    "/images/image-0000072.webp",
    // new food
     "/images/image-0000001.webp",
    "/images/image-0000002.webp",
    "/images/image-0000003.webp",
    "/images/image-0000004.webp",
    "/images/image-0000005.webp",
    "/images/image-0000006.webp",
    "/images/image-0000007.webp",
    "/images/image-0000008.webp",
    "/images/image-0000009.webp",
    "/images/image-0000010.webp",
    "/images/image-0000011.webp",
    "/images/image-0000012.webp",
    "/images/image-0000013.webp",
    "/images/image-0000014.webp",
    "/images/image-0000015.webp",
    "/images/image-0000016.webp",
    "/images/image-0000017.webp",
    "/images/image-0000018.webp",
    "/images/image-0000019.webp",
    "/images/image-0000020.webp",
    "/images/image-0000021.webp",
    "/images/image-0000022.webp",
    "/images/image-0000023.webp",
    "/images/image-0000024.webp",
    "/images/image-0000025.webp",
    "/images/image-0000026.webp",
    "/images/image-0000027.webp",
    "/images/image-0000028.webp",
    "/images/image-0000029.webp",
    "/images/image-0000030.webp",
    "/images/image-0000031.webp",
    "/images/image-0000033.webp",
    "/images/image-0000034.webp",
    "/images/image-0000073.webp",
    "/images/image-0000074.webp",
    "/images/image-0000075.webp",
    "/images/image-0000076.webp",
    "/images/image-0000077.webp",
    "/images/image-0000078.webp",
    "/images/image-0000079.webp",
    "/images/image-0000080.webp",
    "/images/image-0000081.webp",
    "/images/image-0000082.webp",
    "/images/image-0000083.webp",
    "/images/image-0000084.webp",

    // old
    "/images/DSC01069.webp",
    "/images/DSC01204.webp",
    "/images/DSC01228.webp",
    "/images/DSC01929.webp",
    "/images/DSC08361.webp",
    "/images/DSC08362.webp",
    "/images/DSC08376.webp",
    "/images/DSC08396.webp",
    "/images/DSC08406.webp",
    "/images/DSC08452.webp",
    "/images/DSC08460.webp",
    "/images/DSC08495.webp",
    "/images/DSC08503.webp",
    "/images/DSC08521.webp",
    "/images/DSC08531.webp",
    "/images/DSC08535.webp",
    "/images/DSC08541.webp",
    "/images/DSC08566.webp",
    "/images/DSC08579.webp",
    "/images/DSC08616.webp",
    "/images/DSC08635.webp",
    "/images/DSC08641.webp",
    "/images/DSC08646.webp",
    "/images/DSC08666.webp",
    "/images/DSC08673.webp",
    "/images/DSC08696.webp",
    "/images/DSC08702.webp",
    "/images/DSC08705.webp",
    "/images/DSC08717.webp",
    "/images/DSC08720.webp",
    "/images/DSC08730.webp",
    "/images/DSC08741.webp",
    "/images/DSC08746.webp",
    "/images/DSC08810.webp",
    "/images/DSC08814.webp",
    "/images/DSC08817.webp",
    // new images
   

    
  ];

useEffect(() => {
  const random = [...images].sort(() => Math.random() - 0.5);
  setRandomImages(random);
}, []);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % randomImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(randomImages[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + randomImages.length) % images.length;
    setCurrentIndex(newIndex);
    setSelectedImage(randomImages[newIndex]);
  };

  return (
    <div className="gallery">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center parallax overlay"
        style={{
          backgroundImage: "url(/images/DSC08396.webp)",
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1
            className="text-5xl md:text-6xl font-elegant font-bold mb-4"
            data-aos="fade-up"
          >
            {t("gallery.title")}
          </h1>
          <p
            className="text-xl md:text-2xl"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {t("gallery.subtitle")}
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl md:text-5xl font-elegant font-bold text-marrakech-dark mb-4">
              {t("gallery.magicMoments")}
            </h2>
            <p className="text-lg text-marrakech-clay max-w-2xl mx-auto">
              {t("gallery.magicMomentsDesc")}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {randomImages.map((image, index) => (
              <div
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 20}
                className="image-zoom rounded-lg overflow-hidden shadow-lg cursor-pointer"
                onClick={() => openLightbox(image, index)}
              >
                <img
                  src={image}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-64 object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4">
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white text-4xl hover:text-marrakech-gold transition z-10"
          >
            <FaTimes />
          </button>

          {/* Previous Button */}
          <button
            onClick={prevImage}
            className="absolute left-4 text-white text-4xl hover:text-marrakech-gold transition z-10"
          >
            <FaChevronLeft />
          </button>

          {/* Image */}
          <div className="max-w-6xl max-h-full">
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-full max-h-screen object-contain"
            />
          </div>

          {/* Next Button */}
          <button
            onClick={nextImage}
            className="absolute right-4 text-white text-4xl hover:text-marrakech-gold transition z-10"
          >
            <FaChevronRight />
          </button>

          {/* Image Counter */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-lg">
            {currentIndex + 1} / {randomImages.length}
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-[#72201e] text-white">
        <div className="container mx-auto px-4 text-center" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold mb-6">
            {t("gallery.liveExperience")}
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            {t("gallery.liveExperienceDesc")}
          </p>
          <a
            href="/reservation"
            className="btn-secondary bg-white text-marrakech-terracotta hover:bg-[#72201e] hover:text-white border-white"
          >
            {t("gallery.reserveNow")}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
